import { ComponentWithOwnLabel } from 'Components/Core/types';
import React from 'react';
import { FaExclamationCircle } from 'react-icons/fa';
import { Field, ITextInputProps, TextInput, TextOutput } from '../Core';
import { ListFieldSection, PageSection, Table } from '../Layout';

/*
 * Field with custom label to demo this functionality
 */
const TextInputWithOwnLabel: ComponentWithOwnLabel<ITextInputProps, ITextInputProps> = (props) => {
  return <TextInput {...props} />;
};

TextInputWithOwnLabel.Label = ({ id }) => (
  <label htmlFor={id}>
    Text Input with <strong>Custom Label</strong> Component <FaExclamationCircle />
  </label>
);

const FieldToolkit: React.FC = () => (
  <>
    <PageSection heading="Field Types">
      <ListFieldSection>
        <Field input={<TextInput />} name="textinput1" label="Field" />
        <Field input={<TextInput />} name="textinput2" label="Emphasised Field" emph />
        <Field input={<TextInput />} horizontal name="textinput2" label="Horizontal Field" />
      </ListFieldSection>
    </PageSection>

    <PageSection heading="Fields with Custom Label">
      <ListFieldSection wide>
        <Field input={<TextInputWithOwnLabel />} name="customlabel" label="Field" />
      </ListFieldSection>
      <ListFieldSection wide>
        <Field horizontal input={<TextInputWithOwnLabel />} name="customlabel" label="Field" />
      </ListFieldSection>
    </PageSection>

    <PageSection heading="Fields have Label With Additional Info Dialog Button">
      <ListFieldSection>
        <Field
          input={<TextInput />}
          label="Default Title, Content Text"
          additionalInformationDialogContent="Additional description for the field"
        />
        <Field
          input={<TextInput />}
          label="Custom Title, Content Text"
          additionalInformationDialogContent="Additional description for the field"
          additionalInformationDialogTitle="Custom Title"
        />
        <Field
          input={<TextOutput />}
          label="Custom Title, Content Table"
          additionalInformationDialogContent={
            <Table
              colWidths={[300, 250]}
              colHeaders={['One', 'Two']}
              data={[1, 2, 3].map((value) => [
                <Field input={<TextOutput />} value={value} />,
                <Field input={<TextOutput />} value={value + 1} />,
              ])}
            ></Table>
          }
          additionalInformationDialogTitle="Custom Title"
        />
      </ListFieldSection>
    </PageSection>

    <PageSection heading="Field Messages and Types">
      <ListFieldSection>
        <Field input={<TextInput />} messages={[{ message: 'Default message' }]} label="Field with Message" />

        <Field
          input={<TextInput />}
          messages={[{ severity: 'info', message: 'Info message' }]}
          label="Field with Info Message"
        />

        <Field
          input={<TextInput />}
          messages={[{ severity: 'success', message: 'Success message' }]}
          label="Field with Success Message"
        />

        <Field
          input={<TextInput />}
          messages={[{ severity: 'warning', message: 'Warning message' }]}
          label="Field with Warning Message"
        />

        <Field
          input={<TextInput />}
          messages={[{ severity: 'error', message: 'Error message' }]}
          label="Field with Error Message"
        />

        <Field
          input={<TextInput />}
          messages={[
            {
              severity: 'info',
              message: 'Information  message',
            },
            {
              severity: 'warning',
              message: 'Warning message',
            },
            {
              severity: 'error',
              message: 'Error message',
            },
          ]}
          label="Field with multiple Messages"
        />

        <Field
          input={<TextInput />}
          horizontal={true}
          messages={[
            {
              severity: 'info',
              message: 'Information message that is sufficiently verbose to wrap over multiple lines',
            },
            {
              severity: 'warning',
              message: 'Warning message',
            },
            {
              severity: 'error',
              message: 'Error message',
            },
          ]}
          label="Horizontal field with multiple messages"
        />
      </ListFieldSection>
    </PageSection>
  </>
);

export default FieldToolkit;
